import { logError } from 'fergy-core-react-logging';
import { useEffect, useState } from 'react';
import { FEATURE_FLAGS } from '../../constants/general';
import { MEDALLIA_EMPLOYEE_FORM_ID } from '../../constants/medallia';
import { useEmployee } from '../apollo/employee/employee.hooks';
import { useFeature } from '../features/features.hooks';

const useMedalliaSDK = (callback: () => void) => {
	useEffect(() => {
		const handleSDKLoad = () => {
			callback();
		};

		if (window.KAMPYLE_ONSITE_SDK) {
			handleSDKLoad();
		} else {
			window.addEventListener('neb_OnsiteLoaded', handleSDKLoad);
		}

		return () => {
			window.removeEventListener('neb_OnsiteLoaded', handleSDKLoad);
		};
	}, []);
};

export const useMedalliaEmployeeForm = () => {
	const { employee } = useEmployee();
	const isInternal = employee.isAuthenticated;
	const employeeFormEnabled = useFeature(FEATURE_FLAGS.MEDALLIA_EMPLOYEE_FORM);

	const loadEmployeeForm = () => {
		if (isInternal && employeeFormEnabled) {
			window.KAMPYLE_ONSITE_SDK.loadForm(MEDALLIA_EMPLOYEE_FORM_ID);
		}
	};

	useMedalliaSDK(loadEmployeeForm);
};

export const useMedallia = (formId: number) => {
	const [isMedalliaLoaded, setIsMedalliaLoaded] = useState(false);

	const openMedalliaForm = () => {
		window.KAMPYLE_ONSITE_SDK.showForm(formId);
	};

	const loadCustomerForm = () => {
		const formLoaded = window.KAMPYLE_ONSITE_SDK.loadForm(formId);
		if (formLoaded) {
			setIsMedalliaLoaded(true);
		} else {
			logError(`Unable to load medallia form ${formId}`);
		}
	};

	useMedalliaSDK(loadCustomerForm);

	return { openMedalliaForm, isMedalliaLoaded };
};
